import { createAction } from '@reduxjs/toolkit';

import { actionPayload } from 'modules/helpers';

import { ActionTypes } from 'literals';

export const login = createAction(
  ActionTypes.USER_LOGIN_REQUEST,
  (coach: number, isContinue?: boolean) => actionPayload({ coach, isContinue }),
);
export const loginSuccess = createAction(ActionTypes.USER_LOGIN_SUCCESS);
export const loginFailure = createAction(ActionTypes.USER_LOGIN_FAILURE, (error: string) =>
  actionPayload(error),
);

export const logOut = createAction(ActionTypes.USER_LOGOUT_REQUEST);
export const logOutSuccess = createAction(ActionTypes.USER_LOGOUT_SUCCESS);

export const userAnswer = createAction(ActionTypes.USER_ANSWER_REQUEST, (answer?: string) =>
  actionPayload(answer),
);
export const userAnswerSuccess = createAction(
  ActionTypes.USER_ANSWER_SUCCESS,
  (question: string, stream: boolean = false) => actionPayload(question, stream),
);
export const userAnswerFailure = createAction(ActionTypes.USER_ANSWER_FAILURE);

export const setSession = createAction(
  ActionTypes.USER_SET_SESSION,
  (sessionId: string, interviewRecordId: string) =>
    actionPayload({ sessionId, interviewRecordId }),
);

export const setName = createAction(ActionTypes.USER_SET_NAME, (name: string) =>
  actionPayload(name),
);

export const setEmail = createAction(ActionTypes.USER_SET_EMAIL, (email: string) =>
  actionPayload(email),
);

export const setListen = createAction(ActionTypes.USER_SET_LISTEN, (listen: boolean) =>
  actionPayload(listen),
);

export const setSaving = createAction(ActionTypes.USER_SET_SAVING, (saving: boolean) =>
  actionPayload(saving),
);

export const userSpeak = createAction(ActionTypes.USER_SPEAK_REQUEST, (text: string) =>
  actionPayload(text),
);
export const userSpeakSuccess = createAction(ActionTypes.USER_SPEAK_SUCCESS, (url: string) =>
  actionPayload(url),
);
export const userSpeakFailure = createAction(ActionTypes.USER_SPEAK_FAILURE);

export const userExport = createAction(ActionTypes.USER_EXPORT_REQUEST);
export const userExportSuccess = createAction(ActionTypes.USER_EXPORT_SUCCESS, (payload: any) =>
  actionPayload(payload),
);
export const userExportFailure = createAction(ActionTypes.USER_EXPORT_FAILURE);
